// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".promotion_banner_card[data-v-5bea8180]{grid-template-rows:10px 1fr 1fr 10px;grid-template-columns:1fr 1fr 1fr 1fr 1fr 192px;max-width:1200px}.slim_banner[data-v-5bea8180]{max-width:1200px}@media only screen and (max-width:991px){.carousel_ver2 .carousel__pagination[data-v-5bea8180]{display:none}}@media only screen and (max-width:480px){.promotion_banner_card[data-v-5bea8180]{height:255px}}", ""]);
// Exports
module.exports = exports;
